import React, { useState, useEffect } from 'react';
import logo from '../../../public/assets/images/logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const navLinks = [
    { href: '#slider-sec', label: 'Home' },
    { href: '#about-sec', label: 'About' },
    { href: '#tour-sec', label: 'Tours' },
    { href: '#sercices-sec', label: 'Services' },
    { href: '#gallery-sec', label: 'Gallery' },
    { href: '#contact-sec', label: 'Contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      // Use a smaller threshold and smoother detection
      const scrollPosition = window.scrollY;
      if (scrollPosition > 30) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Throttle the scroll event for better performance
    let ticking = false;
    const throttledScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });
    // Initial check
    handleScroll();
    
    return () => window.removeEventListener('scroll', throttledScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  // Determine if navbar should show background
  const shouldShowBackground = isScrolled || isMenuOpen;

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 py-2 transition-all duration-700 ease-in-out ${
        shouldShowBackground 
          ? 'bg-gradient-to-r from-white/95 to-[#1a237e] shadow-lg' 
          : 'bg-transparent'
      }`}
      style={{
        // Apply transition to all properties for smoothness
        transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
        // Ensure background transitions smoothly
        backgroundColor: shouldShowBackground ? 'rgba(26, 35, 126, 0.95)' : 'transparent',
        backgroundImage: shouldShowBackground 
          ? 'linear-gradient(to right, rgba(255,255,255,0.95), rgba(26, 35, 126, 0.95))' 
          : 'none',
        boxShadow: shouldShowBackground ? '0 4px 20px rgba(0,0,0,0.15)' : 'none',
      }}
    >
      <div className="container mx-auto flex flex-wrap justify-between items-center">
        <a href="#">
          <img 
            style={{ height: '100px', transition: 'all 0.5s ease' }} 
            src={logo} 
            alt="legendLogo" 
            className={!shouldShowBackground ? 'brightness-0 invert' : ''}
          />
        </a>

        <div className="flex items-center md:hidden">
          <button
            id="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            type="button"
            className={`inline-flex items-center p-2 text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-200 transition-all duration-300 ${
              shouldShowBackground 
                ? 'text-gray-700 hover:bg-gray-100' 
                : 'text-white hover:bg-white/10'
            }`}
          >
            <span className="sr-only">Open main menu</span>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>

        <div className={`${isMenuOpen ? 'block' : 'hidden'} w-full md:block md:w-auto`} id="mobile-menu">
          <ul className="flex flex-col md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium list-none" style={{ listStyle: 'none' }}>
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className={`block py-2 pr-4 pl-3 text-lg list-none transition-all duration-300 ${
                    shouldShowBackground 
                      ? 'text-white hover:text-gray-200' 
                      : 'text-white hover:text-gray-200 drop-shadow-lg'
                  }`}
                  style={{
                    transition: 'color 0.3s ease, text-shadow 0.3s ease',
                    textShadow: !shouldShowBackground ? '0 2px 10px rgba(0,0,0,0.3)' : 'none'
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;